import { Box } from '@material-ui/core';
import { Outlet } from 'react-router';

const ModulesLayout = () => (
  <Box padding={3}>
    <Outlet />
  </Box>
);

export default ModulesLayout;
